// generated from 69_556 samples

import { z } from "zod";
import { messageGetBaseSchema } from "./messageGetBaseSchema";

export const controlMessageGetSchema = z.object({
  ...messageGetBaseSchema.shape,
  message_type: z.literal("control"),
  is_active: z.boolean(),
  is_control: z.literal(true),
  // null: 43 (0.06%)
  link_template_ids: z.array(z.string()).nullable(),
  name: z.literal("Control Group"),
  optimal_send_percentage: z.int().min(0).max(100).nullable(),
  send_percentage: z.int().min(0).max(100).nullable(),
});
